import NextLink from 'next/link';

import type { AnchorHTMLAttributes, FC } from 'react';

const DISABLED_NEXT_LINK_PATHS = ['/api'];

type Props = AnchorHTMLAttributes<HTMLAnchorElement>;

/**
 * A Link component which choices between Next.js's Link and a regular anchor tag based on specific conditions.
 *
 * The conditions are:
 * - If the href starts with `/api`, the link is rendered as an anchor tag.
 *
 * In all other cases, the link is rendered as a Next.js Link.
 */
export const SmartLink: FC<Props> = props => {
  const pathname = hrefToPathname(props.href);

  const disabledNextLink = DISABLED_NEXT_LINK_PATHS.some(disabledPath =>
    pathname?.startsWith(disabledPath),
  );

  if (disabledNextLink) {
    return <a {...props} />;
  }

  return <NextLink {...props} href={props.href ?? '#'} />;
};

const hrefToPathname = (href?: string): string | undefined => {
  if (typeof href === 'undefined') {
    return undefined;
  }

  try {
    return new URL(href).pathname;
  } catch {
    return href;
  }
};
